/* nylyCas GalaxyGlow lander — only loaded by sections/ngg-galaxyglow-lander.liquid */
(function () {
  'use strict';
  var root = document.getElementById('ngg');
  if (!root) return;
  var D;
  try { D = JSON.parse(root.querySelector('#ngg-data').textContent); } catch (e) { return; }
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function fmt(cents) {
    cents = Math.round(cents);
    var f = D.moneyFormat || '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function group(n, d, t, s) {
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p[1] ? p[0] + s + p[1] : p[0];
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(cents, 0, '.', ','); break;
      default: v = group(cents, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  var V = {};
  D.variants.forEach(function (v) { V[v.id] = v; });
  var firstAvail = (D.variants.filter(function (v) { return v.available; })[0] || D.variants[0]).id;
  var startId = V[D.selected] && V[D.selected].available ? D.selected : firstAvail;

  var S = {
    tier: D.defaultTier || 1,
    browse: startId,
    slots: {},
    addon: !!(D.addon && D.addonDefault),
    addonVar: D.addon && D.addon.variants.length ? D.addon.variants[0].id : null,
    addonQty: 1,
    xs: {}
  };
  D.tiers.forEach(function (t) { S.slots[t.qty] = []; for (var i = 0; i < t.qty; i++) S.slots[t.qty].push(startId); });

  function tierOf(q) { return D.tiers.filter(function (t) { return t.qty === q; })[0]; }
  /* bundle price = sum of selected variant prices minus the fixed amount of the matching discount code */
  function tierCalc(t) {
    var ids = S.slots[t.qty], line = 0, cmp = 0;
    ids.forEach(function (id) { var v = V[id]; line += v.price; cmp += Math.max(v.compare || 0, v.price); });
    var now = Math.max(0, line - (t.off || 0));
    return { now: now, was: cmp, save: cmp - now, pctOff: cmp > 0 ? Math.round((cmp - now) / cmp * 100) : 0 };
  }
  function addonUnit() {
    if (!D.addon) return 0;
    var a = D.addon.variants.filter(function (v) { return v.id === S.addonVar; })[0];
    return a ? a.price : 0;
  }
  function totals() {
    var t = tierCalc(tierOf(S.tier));
    var now = t.now, was = t.was;
    if (S.addon) { now += addonUnit() * S.addonQty; was += addonUnit() * S.addonQty; }
    D.xs.forEach(function (x) { if (S.xs[x.id]) { now += x.price; was += Math.max(x.compare || 0, x.price); } });
    return { now: now, was: was };
  }

  /* ---------- render ---------- */
  function render() {
    var bv = V[S.browse];
    $$('[data-ngg-pill]').forEach(function (b) { b.classList.toggle('is-active', +b.dataset.nggPill === S.browse); b.setAttribute('aria-pressed', +b.dataset.nggPill === S.browse); });
    var lab = $('[data-ngg-pill-label]'); if (lab) lab.textContent = bv.label;
    var pn = $('[data-ngg-price-now]'); if (pn) pn.textContent = fmt(bv.price);
    var pw = $('[data-ngg-price-was]'); var pb = $('[data-ngg-price-badge]');
    if (pw) { pw.textContent = bv.compare > bv.price ? fmt(bv.compare) : ''; }
    if (pb) { var off = bv.compare > bv.price ? Math.round((bv.compare - bv.price) / bv.compare * 100) : 0; pb.textContent = off ? (D.t.save + ' ' + off + '%') : ''; pb.style.display = off ? '' : 'none'; }

    D.tiers.forEach(function (t) {
      var el = $('[data-ngg-tier="' + t.qty + '"]'); if (!el) return;
      var c = tierCalc(t);
      el.classList.toggle('is-active', S.tier === t.qty);
      el.setAttribute('aria-checked', S.tier === t.qty);
      $('[data-ngg-tnow]', el).textContent = fmt(c.now);
      var w = $('[data-ngg-twas]', el); w.textContent = c.was > c.now ? fmt(c.was) : '';
      var sv = $('[data-ngg-tsave]', el); if (sv) { sv.textContent = c.save > 0 ? D.t.saveAmt.replace('[amount]', fmt(c.save)) : ''; sv.style.display = c.save > 0 ? '' : 'none'; }
      var fp = $('[data-ngg-tpct]', el); if (fp) fp.textContent = c.pctOff ? (c.pctOff + '% ' + D.t.off) : '';
      $$('select[data-ngg-slot]', el).forEach(function (sel, i) { sel.value = String(S.slots[t.qty][i]); });
    });

    var ad = $('[data-ngg-addon]');
    if (ad) {
      ad.classList.toggle('is-on', S.addon);
      $('[data-ngg-addon-switch]', ad).setAttribute('aria-checked', S.addon);
      $('[data-ngg-addon-qty]', ad).textContent = S.addonQty;
    }
    $$('[data-ngg-xs]').forEach(function (c) {
      var on = !!S.xs[+c.dataset.nggXs];
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on);
      $('.ngg-xs__btn', c).textContent = on ? D.t.added : D.t.add;
    });

    var T = totals();
    $$('[data-ngg-total]').forEach(function (e) { e.textContent = fmt(T.now); });
    $$('[data-ngg-total-was]').forEach(function (e) { e.textContent = T.was > T.now ? fmt(T.was) : ''; });
  }

  /* ---------- events: pills / tiers / slots ---------- */
  $$('[data-ngg-pill]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = +b.dataset.nggPill; if (!V[id] || !V[id].available) return;
      S.browse = id;
      Object.keys(S.slots).forEach(function (k) { S.slots[k] = S.slots[k].map(function () { return id; }); });
      render();
    });
  });
  $$('[data-ngg-tier]').forEach(function (el) {
    function pick(e) { if (e && e.target.closest('select')) return; S.tier = +el.dataset.nggTier; render(); }
    el.addEventListener('click', pick);
    el.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('select')) { e.preventDefault(); pick(); } });
    $$('select[data-ngg-slot]', el).forEach(function (sel, i) {
      sel.addEventListener('change', function () { S.slots[+el.dataset.nggTier][i] = +sel.value; S.tier = +el.dataset.nggTier; render(); });
    });
  });

  /* ---------- add-on & cross-sells ---------- */
  var ad = $('[data-ngg-addon]');
  if (ad) {
    $('[data-ngg-addon-switch]', ad).addEventListener('click', function () { S.addon = !S.addon; render(); });
    var asel = $('[data-ngg-addon-var]', ad); if (asel) asel.addEventListener('change', function () { S.addonVar = +asel.value; render(); });
    $('[data-ngg-addon-minus]', ad).addEventListener('click', function () { S.addonQty = Math.max(1, S.addonQty - 1); render(); });
    $('[data-ngg-addon-plus]', ad).addEventListener('click', function () { S.addonQty = Math.min(9, S.addonQty + 1); S.addon = true; render(); });
  }
  $$('[data-ngg-xs]').forEach(function (c) {
    function tog() { var id = +c.dataset.nggXs; S.xs[id] = !S.xs[id]; render(); }
    c.addEventListener('click', tog);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tog(); } });
  });

  /* ---------- add to cart -> apply offer codes -> theme cart drawer ---------- */
  function buildItems() {
    var t = tierOf(S.tier), count = {}, items = [];
    S.slots[t.qty].forEach(function (id) { count[id] = (count[id] || 0) + 1; });
    Object.keys(count).forEach(function (id) {
      var it = { id: +id, quantity: count[id] };
      if (t.qty > 1) it.properties = { _bundle: t.qty + 'x GalaxyGlow' };
      items.push(it);
    });
    (t.gifts || []).forEach(function (g) { items.push({ id: g, quantity: 1, properties: { _gift: 'Free with GalaxyGlow' } }); });
    if (S.addon && S.addonVar) items.push({ id: S.addonVar, quantity: S.addonQty });
    D.xs.forEach(function (x) { if (S.xs[x.id]) items.push({ id: x.id, quantity: 1 }); });
    return items;
  }
  function post(url, body) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'Error'); return j; }); });
  }
  var busy = false;
  function done() { busy = false; $$('[data-ngg-buy]').forEach(function (b) { b.disabled = false; }); }
  function addToCart() {
    if (busy) return; busy = true;
    $$('[data-ngg-buy]').forEach(function (b) { b.disabled = true; });
    var err = $('[data-ngg-err]'); if (err) err.style.display = 'none';
    var t = tierOf(S.tier);
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !!(drawer && typeof drawer.renderContents === 'function');
    var sections = useDrawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var items = buildItems();
    var codes = (t.codes || '').replace(/\s+/g, '');
    var addBody = { items: items };
    if (useDrawer && !codes) { addBody.sections = sections; addBody.sections_url = window.location.pathname; }
    post('cart/add.js', addBody)
      .then(function (added) {
        if (!codes) return added;
        var upd = { discount: codes };
        if (useDrawer) { upd.sections = sections; upd.sections_url = window.location.pathname; }
        return post('cart/update.js', upd);
      })
      .then(function (res) {
        if (!useDrawer || !res.sections) { window.location.href = D.afterAdd || '/cart'; return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: res.sections, id: items[0].id });
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ngg-lander', cartData: res }); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
        done();
      })
      .catch(function (e) {
        done();
        if (err) { err.textContent = e.message || D.t.error; err.style.display = 'block'; }
      });
  }
  $$('[data-ngg-buy]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(); }); });

  /* ---------- gallery ---------- */
  var track = $('[data-ngg-gal-track]');
  if (track) {
    var slides = $$('.ngg-gal__slide', track), thumbs = $$('[data-ngg-thumb]');
    var idx = 0;
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
    function active(i) {
      idx = i; thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var th = thumbs[i]; if (th && th.parentNode) th.parentNode.scrollTo({ left: th.offsetLeft - 20, behavior: 'smooth' });
    }
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { active(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
    var pv = $('[data-ngg-gal-prev]'), nx = $('[data-ngg-gal-next]');
    if (pv) pv.addEventListener('click', function () { go(idx - 1); });
    if (nx) nx.addEventListener('click', function () { go(idx + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
  }

  /* ---------- generic carousels ---------- */
  $$('[data-ngg-carousel]').forEach(function (wrap) {
    var tr = $('[data-ngg-track]', wrap); if (!tr) return;
    function step() { var c = tr.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : tr.clientWidth; }
    var p = $('[data-ngg-prev]', wrap), n = $('[data-ngg-next]', wrap);
    if (p) p.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- videos ---------- */
  $$('.ngg-vid').forEach(function (card) {
    var v = $('video', card), b = $('.ngg-vid__play', card);
    if (!v || !b) return;
    b.addEventListener('click', function () {
      $$('.ngg-vid video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.ngg-vid').classList.remove('is-playing'); } });
      v.controls = true; v.muted = false; v.play(); card.classList.add('is-playing');
    });
    v.addEventListener('ended', function () { card.classList.remove('is-playing'); v.controls = false; });
  });

  /* ---------- how-it-works tabs ---------- */
  $$('[data-ngg-tab]').forEach(function (t) {
    t.addEventListener('click', function () {
      var k = t.dataset.nggTab;
      $$('[data-ngg-tab]').forEach(function (o) { o.classList.toggle('is-active', o === t); o.setAttribute('aria-selected', o === t); });
      $$('[data-ngg-step]').forEach(function (s) { s.classList.toggle('is-active', s.dataset.nggStep === k); });
    });
  });

  /* ---------- countdown (to local midnight) ---------- */
  var timers = $$('[data-ngg-timer]');
  if (timers.length) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      timers.forEach(function (t) { t.textContent = txt; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- sticky CTA ---------- */
  var sticky = $('[data-ngg-sticky]'), anchor = $('[data-ngg-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  }
  $$('a[href="#ngg-buy"]').forEach(function (a) {
    a.addEventListener('click', function (e) { var t = document.getElementById('ngg-buy'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
  });

  render();
})();
